import React, { useEffect, useState } from "react";
import FormDialog from "../../helpers/FormDialog";
import { CheckHasAnyPermission } from "helpers/Common_functions";

export const AllocateEmployee = ({
  onSuccess,
  setOpen,
  open,
  resourceId,
  setValue0,
  value,
  positions,
  structures,
  wholeStructure,
  empStructure
}) => {
  const [select, setSelect] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState();
  const [structurePath, setStructurePath] = useState([]);
  const getChildren = (parent, allStructures) => {
    const parentId = parent?.id || null;
    return allStructures.filter(s => s.parentId === parentId);
  };

  const institutionOptions = getChildren(null, wholeStructure);
  const actionCode = "action.allocate.employee";


  const buildStructurePath = (target, allStructures) => {
    if (!target) return [];
    const path = [];
    let current = target;
    while (current) {
      path.unshift(current);
      current = allStructures.find(s => s.id === current.parentId) || null;
    }
    return path.map((node, idx, arr) => ({
      ...node,
      children: allStructures.filter(s => s.parentId === node.id)
    }));
  };

  useEffect(() => {
    if (empStructure && wholeStructure?.length) {
      const path = buildStructurePath(empStructure, wholeStructure);
      setStructurePath(path);
      setSelectedStructure(empStructure);
    }
  }, [empStructure, wholeStructure]);


  return (
    <>
      <FormDialog
        maxWidth={"md"}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={
          open === 1
            ? "/api/resource/create"
            : `/api/resource/allocate/${resourceId}`
        }
        // title={open === 1 ? "Create New Employee" : "Allocate Employee"}
        title={
          !CheckHasAnyPermission(actionCode, "update")
            ? "Edit Basic Info"
            : "Allocate Employee"
        }
        fields={[
          {
            name: "names",
            label: "Names",
            type: "text",
            value: value["names"],
            required: true,
            setValue: (val) => setValue0("names", val),
          },
          {
            name: "entryDate",
            label: "Entry Date",
            type: "date",
            // value: value["entryDate"].moment().format("YYYY-MM-DD") || moment().format("YYYY-MM-DD"),
            value: value["entryDate"],
            // value: value["
            required: true,
            setValue: (val) => setValue0("entryDate", val),
          },
          {
            name: "positionId",
            label: "Position",
            type: "select",
            values: positions,
            value: value["positionId"],
            required: true && CheckHasAnyPermission(actionCode, "update"),
            // setValue: (val) => setValue0("positionId", val),
            setValue: (val) => setValue0("positionId", val),
            disabled: !CheckHasAnyPermission(actionCode, "update"),

          },
          {
            name: "phone",
            label: "Contact Number",
            type: "text",
            value: value["phone"],
            setValue: (val) => setValue0("phone", val),
          },
          ...(CheckHasAnyPermission(actionCode, 'read') ? [
            {
              name: "institution",
              label: "Institution",
              type: "select",
              values: institutionOptions.map(opt => ({ label: opt.name, value: opt.id })),
              value: structurePath[0]?.id || "",
              // required: true,
              setValue: (val) => {
                const selected = institutionOptions.find(opt => opt.id === val);
                const newPath = selected ? [selected] : [];
                setStructurePath(newPath);
                setSelectedStructure(selected);
                setValue0("structureId", selected?.id || "");
              }
            },
          ] : []),
          ...(structurePath[0]?.children?.length > 0 ? [{
            name: "office",
            label: "Office",
            type: "select",
            values: (structurePath[0]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[1]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[0]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], selected] : [structurePath[0]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[0]);
              setValue0("structureId", selected ? selected.id : structurePath[0].id);
            }
          }] : []),
          ...(structurePath[1]?.children?.length > 0 ? [{
            name: "dipartment",
            label: structurePath[2]?.category || "Department",
            type: "select",
            values: (structurePath[1]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[2]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[1]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], structurePath[1], selected] : [structurePath[0], structurePath[1]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[1]);
              setValue0("structureId", selected ? selected.id : structurePath[1].id);
            }
          }] : []),
          ...(structurePath[2]?.children?.length > 0 ? [{
            name: "division",
            label: structurePath[3]?.category || "Unit",
            type: "select",
            values: (structurePath[2]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[3]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[2]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [...structurePath.slice(0, 3), selected] : structurePath.slice(0, 3);
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[2]);
              setValue0("structureId", selected ? selected.id : structurePath[2].id);
            }
          }] : []),
        ]}
      />
    </>
  );
};
